import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { Map, List } from 'immutable'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class PinModal extends React.Component {
  static propTypes = {
    btnSize: React.PropTypes.string,
    btnStyle: React.PropTypes.string,
    open: React.PropTypes.bool,
    transactionIds: React.PropTypes.object,
    type: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    onClose: React.PropTypes.func
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      active: false,
      projects: Map({
        ids: List()
      })
    }
  }

  componentWillReceiveProps (props) {
    if (!props.open) return

    this.setState({
      active: true,
      transactionIds: props.transactionIds
    })
  }

  showWindow () {
    this.setState({ active: true })
  }

  hideWindow () {
    const { onClose } = this.props

    this.setState({
      active: false,
      transactionIds: undefined,
      projects: Map({
        ids: List()
      })
    })

    if (onClose) onClose()
  }

  handleOptions (data) {
    return data.map(r => {
      return { value: r.get('id'), label: r.get('name') }
    }).toJS()
  }

  async pinProjects (evt) {
    evt.preventDefault()

    const { transactionIds, type } = this.props
    const { projects } = this.state
    const { store } = this.context

    try {
      await Promise.all(projects.get('ids').map(async id => {
        await store.patch(`/projects/${id}`, transactionIds.map(tId => {
          return {
            op: 'add',
            path: `/pinned/${type.toLowerCase()}s/-`,
            value: tId
          }
        }))
      }))

      this.hideWindow()
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const { title } = this.props
    const ln = createLinkToImmutable(this, 'projects')

    return (
      <div style={{ display: 'inline' }}>
        <Modal show={this.state.active} onHide={::this.hideWindow}>
          <Modal.Header closeButton>
            <h4 className="modal-title">{title}</h4>
          </Modal.Header>

          <Modal.Body>
            <Input
              autoFocus
              multi
              type="select-ajax"
              valueLink={ln('ids')}
              handleOptions={::this.handleOptions}
              name="projects"
              url="/projects"
              label="Project name" />
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="submit"
              bsStyle="warning"
              disabled={!this.state.projects}
              onClick={::this.pinProjects}>
              Add to project(s)
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default PinModal



// WEBPACK FOOTER //
// ./modules/shared/components/pinModal.js